import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import axios from "axios";
import { axiosErrorHandler } from "../../../../../swzutils";
import React, { useImperativeHandle, useState } from "react";
import { Spin } from "antd";
import { userHasPermission } from "../../../../../swzutils/UserPermissionsUtil";
import HelpLabel from "../../../components/HelpLabel";
import { StarFilled } from "@ant-design/icons";
import { loggedInUserSelector } from "../../../../../store/slice/auth";
import { useAppSelector } from "../../../../../store";
const RatingsWidget = (props, exportedRef) => {
    const [loadingCustomerRatings, setLoadingCustomerRatings] = useState(false);
    const [loadingDriverRatings, setLoadingDriverRatings] = useState(false);
    const [customerRating, setCustomerRating] = useState(null);
    const [driverRating, setDriverRating] = useState(null);
    const loggedInUser = useAppSelector(loggedInUserSelector);
    useImperativeHandle(exportedRef, () => {
        return {
            refresh
        };
    });
    // useEffect(() => {
    //     refresh()
    // }, []);
    const refresh = () => {
        loadCustomerRatings();
        loadDriverRatings();
    };
    const hasCustomerRatingPermission = () => {
        return userHasPermission(loggedInUser, ['admin:dashboard:execute:customerRatings']);
    };
    const hasDriverRatingPermission = () => {
        return userHasPermission(loggedInUser, ['admin:dashboard:execute:driverRatings']);
    };
    const loadCustomerRatings = () => {
        if (hasCustomerRatingPermission()) {
            setLoadingCustomerRatings(true);
            axios.get(`/admin/v1/dashboard/customer-ratings/${props.date}`)
                .then(response => {
                setCustomerRating(response.data);
            }).catch(error => {
                setCustomerRating(null);
                axiosErrorHandler(error);
            }).finally(() => {
                setLoadingCustomerRatings(false);
            });
        }
    };
    const loadDriverRatings = () => {
        if (hasDriverRatingPermission()) {
            setLoadingDriverRatings(true);
            axios.get(`/admin/v1/dashboard/driver-ratings/${props.date}`)
                .then(response => {
                setDriverRating(response.data);
            }).catch(error => {
                setDriverRating(null);
                axiosErrorHandler(error);
            }).finally(() => {
                setLoadingDriverRatings(false);
            });
        }
    };
    const customerAverageStarRating = customerRating?.averageStarRating ?? 0;
    const customerAverageStarRatingRounded = Math.round(customerAverageStarRating * 10) / 10;
    const driverAverageStarRating = driverRating?.averageStarRating ?? 0;
    const driverAverageStarRatingRounded = Math.round(driverAverageStarRating * 10) / 10;
    const showCustomerRating = hasCustomerRatingPermission();
    const showDriverRating = hasDriverRatingPermission();
    return (_jsx(Spin, { spinning: loadingDriverRatings || loadingCustomerRatings, children: _jsxs("div", { className: "widget", children: [showCustomerRating &&
                    _jsxs(_Fragment, { children: [_jsx("div", { className: "widget-icon widget-icon-coral", children: _jsx(StarFilled, {}) }), (customerAverageStarRating)
                                ? _jsxs("h2", { className: "widget-value", children: [customerAverageStarRatingRounded, _jsx("span", { className: "small", children: "/5" }), " ", _jsx(StarFilled, {})] })
                                : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Average customer rating", helpText: _jsx("div", { children: _jsx("p", { children: "The average of customer ratings given for all deliveries." }) }) }) })] }), showCustomerRating && showDriverRating &&
                    _jsx("div", { className: "widget-separator" }), showDriverRating &&
                    _jsxs(_Fragment, { children: [(driverAverageStarRating)
                                ? _jsxs("h2", { className: "widget-value", children: [driverAverageStarRatingRounded, _jsx("span", { className: "small", children: "/5" }), " ", _jsx(StarFilled, {})] })
                                : _jsx("h2", { className: "widget-value", children: "\u2014" }), _jsx("p", { children: _jsx(HelpLabel, { title: "Average driver rating", helpText: _jsx("div", { children: _jsx("p", { children: "The average of driver ratings given for all deliveries." }) }) }) })] })] }) }));
};
export default React.forwardRef(RatingsWidget);
